<template>
  <div class="regra-modal__caixa regra-negocio-binds">
    <div class="regra-negocio-binds__busca">
      <input
        class="form-control form-control-sm"
        type="text"
        v-model="termo"
        placeholder="Buscar variável..."
        aria-label="Buscar variável"
      />
      <small class="regra-negocio-binds__total">{{ bindsFiltered.length }} de {{ binds.length }}</small>
    </div>
    <ul class="regra-negocio-binds__lista">
      <li v-if="!bindsFiltered.length" class="regra-negocio-binds__vazio">
        {{ carregando ? "Carregando variáveis..." : "Nenhuma variável encontrada" }}
      </li>
      <li v-for="row in bindsFiltered" :key="row.bind" class="regra-negocio-binds__item">
        <button
          type="button"
          class="regra-negocio-binds__inserir"
          :title="`Inserir ${row.bind} na consulta`"
          @click="$emit('inserir', row.bind)"
        >
          <code class="regra-negocio-binds__nome">{{ row.bind }}</code>
          <span class="regra-negocio-binds__descricao">{{ row.descricao }}</span>
        </button>
        <CButton
          size="sm"
          :color="copiado === row.bind ? 'success' : 'secondary'"
          variant="ghost"
          :title="copiado === row.bind ? 'Copiado' : 'Copiar variável'"
          :aria-label="`Copiar a variável ${row.bind}`"
          @click="copyBind(row.bind)"
        >
          <fa-icon :icon="copiado === row.bind ? 'check' : 'copy'" />
        </CButton>
      </li>
    </ul>
  </div>
</template>

<script>
import { arrayFilter } from "@/helpers/utils";
import { copiarTexto } from "@/views/Cashback/components/copiarTexto";

const DURACAO_COPIADO_MS = 1500;

export default {
  name: "bindsList",

  props: {
    binds: { type: Array, default: () => [] },
    carregando: { type: Boolean, default: false },
  },

  data() {
    return {
      termo: "",
      copiado: null,
    };
  },

  computed: {
    bindsFiltered() {
      if (!this.termo) {
        return this.binds;
      }

      return arrayFilter(this.binds, this.termo, ["bind", "descricao"]);
    },
  },

  methods: {
    copyBind(bind) {
      copiarTexto(bind)
        .then(() => {
          this.copiado = bind;
          clearTimeout(this.temporizadorCopiado);
          this.temporizadorCopiado = setTimeout(() => {
            this.copiado = null;
          }, DURACAO_COPIADO_MS);
        })
        .catch(() => {
          this.$swal({ title: "Não foi possível copiar", text: bind, icon: "warning" });
        });
    },
  },

  beforeDestroy() {
    clearTimeout(this.temporizadorCopiado);
  },
};
</script>

<style scoped src="@/components/regras/regra-modal.css"></style>

<style scoped>
.regra-negocio-binds {
  display: flex;
  flex-direction: column;
}

.regra-negocio-binds__busca {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 12px;
  border-bottom: 1px solid #eaecf0;
  background-color: #f9fafb;
}

.regra-negocio-binds__total {
  flex-shrink: 0;
  font-size: 11px;
  color: #98a2b3;
}

.regra-negocio-binds__lista {
  flex: 1;
  min-height: 0;
  margin: 0;
  padding: 0;
  overflow-y: auto;
  list-style: none;
}

.regra-negocio-binds__item {
  display: flex;
  align-items: center;
  gap: 4px;
  padding-right: 6px;
  border-bottom: 1px solid #f2f4f7;
}

.regra-negocio-binds__inserir {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
  padding: 7px 12px;
  border: none;
  background: none;
  text-align: left;
  cursor: pointer;
}

.regra-negocio-binds__inserir:hover,
.regra-negocio-binds__inserir:focus-visible {
  outline: none;
  background-color: var(--cashback-cor-primaria-suave);
}

.regra-negocio-binds__nome {
  font-size: 12px;
  color: var(--cashback-cor-primaria);
  word-break: break-all;
}

.regra-negocio-binds__descricao {
  font-size: 11.5px;
  color: #667085;
}

.regra-negocio-binds__vazio {
  padding: 24px 14px;
  text-align: center;
  font-size: 12.5px;
  color: #98a2b3;
}
</style>
